import React from "react";
import img1 from "../assets/Birthday_img1.png";
import img3 from "../assets/heroimg.jpeg";
import img2 from "../assets/Wedding_img6.png";
import img4 from "../assets/Corporate_img2.png";
import img5 from "../assets/Graduation_img3.png";
import img6 from "../assets/glamboothh.jpeg";

const images = [img1, img2, img3, img4, img5, img6];

export default function GallerySection() {
  // layout for desktop mosaic (4 columns)
  const mosaicLayout = [
    { src: images[0], span: "col-span-2 row-span-2" }, // big feature image
    { src: images[1], span: "col-span-2 row-span-1" }, // wide
    { src: images[2], span: "col-span-1 row-span-1" },
    { src: images[3], span: "col-span-1 row-span-1" },
    { src: images[4], span: "col-span-2 row-span-1" }, // bottom wide
    { src: images[5], span: "col-span-2 row-span-1" }, // bottom wide
  ];

  return (
    <section
      id="gallery"
      className="py-24 bg-slate-950 text-white relative overflow-hidden"
    >
      {/* Background glows */}
      <div className="pointer-events-none absolute -top-20 left-0 w-80 h-80 bg-[#E34364]/25 blur-[120px] opacity-40" />
      <div className="pointer-events-none absolute bottom-0 right-0 w-96 h-96 bg-purple-700/30 blur-[140px] opacity-40" />

      <div className="relative max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14 animate-fade-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#E34364] mb-2">
            Memories
          </p>
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            Memories in Motion
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            From weddings and birthdays to corporate events and graduations —
            here’s a peek at the energy PixlyBooth brings to every celebration.
          </p>
        </div>

        {/* MOBILE / TABLET: simple grid */}
        <div className="grid grid-cols-2 gap-4 md:hidden">
          {images.map((src, i) => (
            <div
              key={i}
              className="relative overflow-hidden rounded-2xl bg-slate-900 shadow-lg shadow-black/50 group animate-fade-up"
              style={{ animationDelay: `${i * 0.06}s` }}
            >
              <img
                src={src}
                alt="PixlyBooth event"
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-400" />
            </div>
          ))}
        </div>

        {/* DESKTOP: mosaic layout */}
        <div className="hidden md:grid grid-cols-4 auto-rows-[170px] gap-5 lg:gap-6">
          {mosaicLayout.map((item, i) => (
            <div
              key={i}
              className={`
                relative overflow-hidden rounded-3xl
                bg-gradient-to-br from-slate-900 via-slate-900/70 to-slate-800
                shadow-[0_10px_30px_-8px_rgba(0,0,0,0.7)]
                group animate-fade-up
                hover:shadow-[0_18px_40px_-10px_rgba(227,67,100,0.35)]
                transition-all duration-500
                ${item.span}
              `}
              style={{ animationDelay: `${i * 0.07}s` }}
            >
              {/* glow border on hover */}
              <div className="absolute inset-0 rounded-3xl border border-transparent group-hover:border-[#E34364]/40 group-hover:shadow-[0_0_25px_3px_rgba(227,67,100,0.3)] transition-all duration-500" />

              <img
                src={item.src}
                alt="PixlyBooth event"
                className="w-full h-full object-cover rounded-3xl transition-transform duration-[800ms] ease-[cubic-bezier(.22,.68,0,.99)] group-hover:scale-[1.08]"
              />

              {/* gradient overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />

              {/* small label */}
              <div className="absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 translate-y-3 group-hover:translate-y-0 transition-all duration-500">
                <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/15 rounded-full px-3 py-1 text-xs text-gray-100 shadow-lg">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                  Captured at a PixlyBooth event
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* small floating highlight */}
        <div className="pointer-events-none absolute -top-6 left-1/2 -translate-x-1/2 w-40 h-40 bg-white/5 blur-3xl rounded-full opacity-30 animate-float-slow" />
      </div>
    </section>
  );
}
